(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-lists-carousel"] && !window.DesignMode) return;
  try {
    

    // swiper js
    const swiper = new Swiper('.blog-listing', {
        direction: 'horizontal',
        loop: true,
        // speed: 1000,
        spaceBetween: 25,
        slidesPerView: 3,
        // autoplay: true,
        observer: true,
        observeParents: true,
        
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 1,
            },
            640: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
        },
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-ebike-page"] && !window.DesignMode) return;
  try {
    
	   
    // swiper js
    document.addEventListener('DOMContentLoaded', function() {  
        function initializeSwiper(selector) {
        return new Swiper(selector, {
            direction: 'horizontal',
            speed: 1000,
            width: 500,
            spaceBetween: 30,
            autoplay: false,
            navigation: {
                nextEl: '.best-sale-content .swiper-button-next',
                prevEl: '.best-sale-content .swiper-button-prev',
            },
            pagination: {
                el: selector +' .swiper-pagination',
                type: 'progressbar',
            },
            breakpoints: {
                200: { width: 330, spaceBetween: 15 },
                430: { width: 330, spaceBetween: 15 },
                768: { width: 305 },
                1024: { width: 330 },
                1280: { width: 350 },
                1536: { width: 400 },
                1600: { width: 475 },
                1920: { width: 500 },
            },
        });
        }

        function initializeSwiperForTab(tab) {
        const carousel = tab.querySelector('.swiper-best-sale');
        const carouselId = carousel.dataset.carouselId;
        initializeSwiper(`[data-carousel-id="${carouselId}"]`);
        }

        function initializeSwipersForActiveTab() {
        const activeTab = document.querySelector('.best-sale-content .tab-pane.active');
        if (activeTab) {
            initializeSwiperForTab(activeTab);
        }
        }

        document.querySelectorAll('.best-sale-nav-tabs .nav-link').forEach(tab => {
        tab.addEventListener('click', () => {
            document.querySelectorAll('.best-sale-nav-tabs .nav-link').forEach(tab => {
            tab.classList.remove('active');
            });
            tab.classList.add('active');
            initializeSwipersForActiveTab();
        });
        });

        initializeSwipersForActiveTab();
    
        //toggle variant colors
        var colorItems = document.querySelectorAll('.variant-option-block .variant-colors .variant-color-item');

        colorItems.forEach(function(colorItem) {
            colorItem.addEventListener('click', function() {

            var siblings = this.parentElement.querySelectorAll('.variant-color-item');
            siblings.forEach(function(sibling) {
                sibling.classList.remove('on');
            });

            this.classList.add('on');

            var productItem = this.closest('.product-item');
            var imgItem = productItem.querySelector('.variant-img-item img');
            imgItem.src = this.getAttribute('data-product-img');
            });
        });
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"] && !window.DesignMode) return;
  try {
    
	   
    // swiper js
    document.addEventListener('DOMContentLoaded', function() {  
        function initializeSwiper(selector) {
        return new Swiper(selector, {
            direction: 'horizontal',
            speed: 1000,
            width: 500,
            spaceBetween: 30,
            autoplay: false,
            navigation: {
                nextEl: '.best-sale-content .swiper-button-next',
                prevEl: '.best-sale-content .swiper-button-prev',
            },
            pagination: {
                el: selector +' .swiper-pagination',
                type: 'progressbar',
            },
            breakpoints: {
                200: { width: 330, spaceBetween: 15 },
                430: { width: 330, spaceBetween: 15 },
                768: { width: 305 },
                1024: { width: 330 },
                1280: { width: 350 },
                1536: { width: 400 },
                1600: { width: 475 },
                1920: { width: 500 },
            },
        });
        }

        function initializeSwiperForTab(tab) {
        const carousel = tab.querySelector('.swiper-best-sale');
        const carouselId = carousel.dataset.carouselId;
        initializeSwiper(`[data-carousel-id="${carouselId}"]`);
        }

        function initializeSwipersForActiveTab() {
        const activeTab = document.querySelector('.best-sale-content .tab-pane.active');
        if (activeTab) {
            initializeSwiperForTab(activeTab);
        }
        }

        document.querySelectorAll('.best-sale-nav-tabs .nav-link').forEach(tab => {
        tab.addEventListener('click', () => {
            document.querySelectorAll('.best-sale-nav-tabs .nav-link').forEach(tab => {
            tab.classList.remove('active');
            });
            tab.classList.add('active');
            initializeSwipersForActiveTab();
        });
        });

        initializeSwipersForActiveTab();
    
        //toggle variant colors
        var colorItems = document.querySelectorAll('.variant-option-block .variant-colors .variant-color-item');

        colorItems.forEach(function(colorItem) {
            colorItem.addEventListener('click', function() {

            var siblings = this.parentElement.querySelectorAll('.variant-color-item');
            siblings.forEach(function(sibling) {
                sibling.classList.remove('on');
            });

            this.classList.add('on');

            var productItem = this.closest('.product-item');
            var imgItem = productItem.querySelector('.variant-img-item img');
            imgItem.src = this.getAttribute('data-product-img');
            });
        });
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customized-header-banner"] && !window.DesignMode) return;
  try {
    

$(document).ready(function() {
  var currentPage = 1;
  var itemsPerPage = 1;
  var totalSlides = $('.data p').length;
  var totalPages = Math.ceil(totalSlides / itemsPerPage);

  // Add active class for the first element by default
  $('.sliderbutton-wrapper').first().addClass('active');

  $('.sliderbutton-wrapper').on('click', function() {
    var page = parseInt($(this).data('page'));
    goToPage(page);

    // Toggle class "slider-is-active" on CustomizeHeaderBanner
    $("#CustomizeHeaderBanner").toggleClass("slider-is-active", !$(this).is(":first-child"));
  });

  function goToPage(page) {
    if (page >= 1 && page <= totalPages) {
      currentPage = page;
      triggerSlide();
      updateButtonState();
    }
  }

  function triggerSlide() {
    var start = (currentPage - 1) * itemsPerPage;
    var end = start + itemsPerPage;
    $('.data p').removeClass('active').slice(start, end).addClass('active');

    var activeElement = $('.data p.active');
    var title = activeElement.data('title');
    var description = activeElement.data('description');
    var image = activeElement.data('image');
    var price = activeElement.data('price');
    var body = activeElement.data('body');
    var motor = activeElement.data('motor');
    var battery = activeElement.data('battery');

    // Add transition effect for opacity
    $('.text-data').css('opacity', 0);

    // Update content after a short delay
    setTimeout(() => {
      $('.text-data .price span').html(price);
      $('.text-data .body span').html(body);
      $('.text-data .motor span').html(motor);
      $('.text-data .battery span').html(battery);

      // Remove transition effect
      $('.text-data').css('opacity', 1);

      $('.slide').css('left', '-100%');

      setTimeout(() => {
        $('.slide .title').html(title);
        $('.slide .description').html(description);
        $('.slide img').attr('src', image);

        $('.slide').css('left', '0');
      }, 500);
    }, 300); // Adjust the delay according to your preference
  }

  function updateButtonState() {
    $('.sliderbutton-wrapper').removeClass('active');
    $('.sliderbutton-wrapper[data-page="' + currentPage + '"]').addClass('active');
  }

  // Initial setup
  triggerSlide();

});




    
    //when scroll slide the object on the left side of this section slider
    function isInViewport(element) {
        var elementTop = $(element).offset().top;
        var elementHeight = $(element).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementTop + elementHeight / 1 < viewportBottom;
    }

    $(window).scroll(function() {
    // Check if section2 is in the viewport
    if (isInViewport('.feature-slider')) {
        // Add a class to trigger the slide animation
        $('.slide-wrapper-inner').addClass('slide-animation');
    }

    //toggle variant colors
        var colorItems = document.querySelectorAll('.variant-option-block .variant-colors .variant-color-item');

        colorItems.forEach(function(colorItem) {
            colorItem.addEventListener('click', function() {

            var siblings = this.parentElement.querySelectorAll('.variant-color-item');
            siblings.forEach(function(sibling) {
                sibling.classList.remove('on');
            });

            this.classList.add('on');

            var productItem = this.closest('.product-item');
            var imgItem = productItem.querySelector('.variant-img-item img');
            imgItem.src = this.getAttribute('data-product-img');
            });
        });
    });
    
  //pop up video  
  document.addEventListener('DOMContentLoaded', function() {
    const videoButton = document.getElementById('videoButton');
    const videoPopup = document.getElementById('videoPopup');
    const closeButton = document.getElementById('closeButton');
    const videoIframe = document.getElementById('videoIframe');

    videoButton.addEventListener('click', function() {
        videoPopup.style.display = 'flex';
        document.body.style.overflow = 'hidden'; // Add this line to hide overflow
    });

    closeButton.addEventListener('click', function() {
        videoPopup.style.display = 'none';
        document.body.style.overflow = 'auto'; // Reset overflow when closing
        // Pause video when closing the popup (optional)
        videoIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });

    // Close popup when clicking outside of it
    window.addEventListener('click', function(event) {
        if (event.target === videoPopup) {
            videoPopup.style.display = 'none';
            document.body.style.overflow = 'auto'; // Reset overflow when closing
            // Pause video when closing the popup (optional)
            videoIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customized-order-content"]) return;
  try {
    
  // add/remove active state for the product variation color
  $(document).ready(function() {
    $('.customVariant-color').click(function() {
      // Remove active class from all customVariantColor-items
      $('.customVariantColor-item').removeClass('active');
      // Add active class to the parent customVariantColor-item of the clicked customVariant-color
      $(this).closest('.customVariantColor-item').toggleClass('active');
    });

    //.custom-size-group by 2 
    var elements = $('.custom-size-group');
    for(var i = 0; i < elements.length; i += 2) {
        elements.slice(i, i + 2).wrapAll('<div class="customSize-groupWrapper"></div>');
    }
  });


  // Add active class to the default custom-size element
  $(document).ready(function() {
      $('.customSize-groupWrapper:first-child .custom-size-group:first-child .custom-size, .customSize-groupWrapper:first-child .custom-size-group:first-child .size-button').addClass('active');
  });

  // Handle click event to toggle active class based on data-metafield
  $('.size-button').click(function() {
      var metafield = $(this).data('metafield');
      $('.custom-size-group').each(function() {
          if ($(this).data('metafield') === metafield) {
            $(this).find('.custom-size, .size-button').addClass('active');

          } else {
            $(this).find('.custom-size, .size-button').removeClass('active');
          }
      });
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-slider"] && !window.DesignMode) return;
  try {
    

    var slide = 1;
    var totalSlide = $('.data p').length;

    $('button.prev').on('click', function () {
        if (slide > 1) {
            slide--;
            triggerSlide(slide);
        }
        updateButtonState();
    });

    $('button.next').on('click', function () {
        if (slide < totalSlide) {
            slide++;
            triggerSlide(slide);
        }
        updateButtonState();
    });

    function triggerSlide(slide) {
        $(`.data p:eq(${slide - 1})`).addClass('active').siblings().removeClass('active');

        let title = $('.data p.active').data('title');
        let description = $('.data p.active').data('description');
        let image = $('.data p.active').data('image');

        let price = $('.data p.active').data('price');
        let body = $('.data p.active').data('body');
        let motor = $('.data p.active').data('motor');
        let battery = $('.data p.active').data('battery');

        // Add transition effect for opacity
        $('.text-data').css('opacity', 0);

        // Update content after a short delay
        setTimeout(() => {
            $('.text-data .price span').html(price);
            $('.text-data .body span').html(body);
            $('.text-data .motor span').html(motor);
            $('.text-data .battery span').html(battery);

            // Remove transition effect
            $('.text-data').css('opacity', 1);

            $('.slide').css('left', '-100%');

            setTimeout(() => {
                $('.slide .title').html(title);
                $('.slide .description').html(description);
                $('.slide img').attr('src', image);

                $('.slide').css('left', '0');
            }, 500);
        }, 300); // Adjust the delay according to your preference
    }

    function updateButtonState() {
        $('button.prev').toggleClass('active', slide > 1);
        $('button.next').toggleClass('active', slide < totalSlide);
    }

    
    //when scroll slide the object on the left side of this section slider
    function isInViewport(element) {
        var elementTop = $(element).offset().top;
        var elementHeight = $(element).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementTop + elementHeight / 2 < viewportBottom;
    }

    $(window).scroll(function() {
    // Check if section2 is in the viewport
    if (isInViewport('.feature-slider')) {
        // Add a class to trigger the slide animation
        $('.slide-wrapper-inner').addClass('slide-animation');
    }
    });
    
    
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["four-columns-block-icon"] && !window.DesignMode) return;
  try {
    

    //the mobile version
    // swiper js
    const swiper = new Swiper('.fourColumn-mobile', {
        direction: 'horizontal',
        loop: false,
        speed: 1000,
        spaceBetween: 20,
        autoplay: false,
        observer: true,
        observeParents: true,
        autoHeight: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable:'true'
        }
    });
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fullWidth-verticalBanner"] && !window.DesignMode) return;
  try {
     

    const interleaveOffset = 0.75;

    var swiper = new Swiper('.fullVertical-banner', {
        direction: 'vertical',
        speed: 800,
        mousewheelControl: true,
        watchSlidesProgress: true,
        mousewheel: {
            releaseOnEdges: true,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',

            renderBullet: function (index, className) {
                var headingText = document.querySelectorAll('.fullBanner-item .banner-headingText');
                var text = headingText[index].textContent || headingText[index].innerText;
                return '<span class="' + className + '"><div class="custom-bullet"></div><div class="nav-title">' + text + '</div></span>';
            }
        },
        on: {
            init: function () {
                // Check if there is only one slide and hide pagination if true
                if (this.slides.length <= 1) {
                    this.pagination.el.style.display = 'none';
                }
            },

            progress: function() {
            let swiper = this;

            for (let i = 0; i < swiper.slides.length; i++) {
                let slideProgress = swiper.slides[i].progress;
                let innerOffset = swiper.height * interleaveOffset;
                let innerTranslate = slideProgress * innerOffset;

                TweenMax.set(swiper.slides[i].querySelector(".fullBanner-item .slide-inner"), {
                y: innerTranslate,
                });
            }
            },
            setTransition: function(slider, speed) {
                let swiper = this;
                for (let i = 0; i < swiper.slides.length; i++) {
                    swiper.slides[i].style.transition = speed + "ms";
                    swiper.slides[i].querySelector(".fullBanner-item .slide-inner").style.transition =
                    speed + "ms";
                }
            }
        }
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fullWidth-verticalSlider"] && !window.DesignMode) return;
  try {
     

    const interleaveOffset = 0.75;

    var swiper = new Swiper('.fullVertical-slider', {
        direction: 'vertical',
        speed: 800,
        mousewheelControl: true,
        watchSlidesProgress: true,
        mousewheel: {
            releaseOnEdges: true,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',

            renderBullet: function (index, className) {
                return '<span class="' + className + '"><div class="custom-bullet"></div></span>';
            }
        },

        on: {
            progress: function () {
                let swiper = this;

                for (let i = 0; i < swiper.slides.length; i++) {
                    let slideProgress = swiper.slides[i].progress;
                    let innerOffset = swiper.height * interleaveOffset;
                    let innerTranslate = slideProgress * innerOffset;

                    TweenMax.set(swiper.slides[i].querySelector(".fullBanner-sliderItem .slide-inner"), {
                        y: innerTranslate,
                    });

                    // Adding slow fade-up effect for banner content
                    TweenMax.fromTo(swiper.slides[i].querySelector(".bannerContent-inner"), 2, {
                        opacity: 0,
                        y: 50
                    }, {
                        opacity: 1,
                        y: 0,
                        ease: Power2.easeOut
                    });
                }
            },
            setTransition: function (slider, speed) {
                let swiper = this;
                for (let i = 0; i < swiper.slides.length; i++) {
                    swiper.slides[i].style.transition = speed + "ms";
                    swiper.slides[i].querySelector(".fullBanner-sliderItem .slide-inner").style.transition =
                        speed + "ms";
                }
            },
            reachEnd: function () {
                let swiper = this;
                scrollToNextSection();
            }
        }
    });



    function scrollToNextSection() {
        var videoInnerWrapper = jQuery('.video-innerWrapper');

        if (isElementVisible(videoInnerWrapper)) {
            videoInnerWrapper.addClass('resize');
        }
    }

    function isElementVisible(element) {
        var windowHeight = jQuery(window).height();
        var elementTop = element.offset().top;
        var elementBottom = elementTop + element.height();

        return (elementBottom <= (windowHeight + jQuery(window).scrollTop()) && elementTop >= jQuery(window).scrollTop());
    }

    // Call scrollToNextSection on scroll events
    jQuery(window).scroll(scrollToNextSection);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !window.DesignMode) return;
  try {
    
	   
    // swiper js
        return new Swiper('.gallery-carousel-container', {
            direction: 'horizontal',
            speed: 1000,
            spaceBetween: 30,
            autoplay: false,
            loop: true,
            navigation: {
                nextEl: '.gallery-carousel .swiper-button-next',
                prevEl: '.gallery-carousel  .swiper-button-prev',
            },
            breakpoints: {
                200: { width: 300, spaceBetween: 15 },
                768: { width: 300 , spaceBetween: 15},
                1024: { width: 400, spaceBetween: 20 },
                1280: { width: 400 , spaceBetween: 20},
                1536: { width: 442, spaceBetween: 30 },
                1600: { width: 442, spaceBetween: 30 },
                1920: { width: 442, spaceBetween: 30 },
            }
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  

    if ($(window).width() < 1200) {
        $('ul.gap-big .van-mm-item .mega-menu .mega-tab-content').remove();
    }

    function checkWindowWidth() {
        if ($(window).width() < 1200) {
            $('ul.gap-big .van-mm-item .mega-menu .mega-tab-content').remove();
        }
    }

    checkWindowWidth();

    $(window).resize(checkWindowWidth);

    jQuery(document).ready(function(){

      $('.equipment-navItem a:first-child').addClass('active');

      $('.equipment-navItem a').click(function(e) {
        e.preventDefault();
        
        // Remove 'active' class from all anchor tags
        $('.equipment-navItem a').removeClass('active');
        
        // Add 'active' class to the clicked anchor tag
        $(this).addClass('active');
      });

      $('.btn-close-mobile-menu').click(function(){
        $('body').removeClass('custom-mobileMenu-open');
      });
      
    });

 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlights"] && !window.DesignMode) return;
  try {
    
	   
    // swiper js
    document.addEventListener('DOMContentLoaded', function() {  
        return new Swiper('.highlights-innerSlider', {
            direction: 'horizontal',
            speed: 1000,
            spaceBetween: 100,
            autoplay: false,
            navigation: {
                nextEl: '.highlights-slider .swiper-button-next',
                prevEl: '.highlights-slider .swiper-button-prev',
            },
          
            pagination: {
                el: '.highlights-slider .swiper-pagination',
                clickable: true,
                type: 'bullets'
            },

            breakpoints: {
                200: { width: 300, spaceBetween: 20, },
                768: { width: 500 , spaceBetween: 30},
                1024: { width: 900, spaceBetween: 50 },
                1280: { width: 1100 , spaceBetween: 70},
                1536: { width: 1100, spaceBetween: 70 },
                1600: { width: 1325, spaceBetween: 100 },
                1920: { width: 1325, spaceBetween: 100 },
            }
        });
        
    });
	
  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["imageLeft-tableRight"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
        $("#toggleBtn").click(function(){
            $(".specContent").slideToggle();
            $(this).toggleClass("active");
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"] && !window.DesignMode) return;
  try {
    

    //loader
    document.addEventListener("DOMContentLoaded", function () {
        // Display loader initially
        const loader = document.getElementById("loader");
        const resultsContainer = document.getElementById("results-container");

        loader.style.display = "flex";
        resultsContainer.style.display = "none";

        // set time out
        setTimeout(function () {
            // Hide loader and display results after a delay
            loader.style.display = "none";
            resultsContainer.style.display = "flex";
        }, 2000);
    });



    //update the product image based on the variant dots colors
    $(function(){
        $(".variant-option-block .variant-colors .variant-color-item").click(function(){
            $(this).addClass("on").siblings('.variant-color-item').removeClass('on');
            $(this).parents('.product-item').find('.image-card img').attr('src', $(this).attr('data-product-img'));
        })
    })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["object-fullVideo-onScroll"] && !window.DesignMode) return;
  try {
    

    /*function isInView(element) {
        var rect = element.getBoundingClientRect();
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return (
            rect.top <= windowHeight / 2 &&
            rect.bottom >= windowHeight / 2
        );
    }

    
    var videoWrapper = $(".video-innerWrapper");
    var video = $("#cone-video")[0]; // Get the native DOM element
    var isPlaying = false;
    var scrollCount = 0;

    $(document).on('wheel', function(event) {
        if (isInView(videoWrapper[0])) {
            if (event.originalEvent.deltaY > 0) {
                // Mouse wheel scrolled down
                if (!isPlaying) {
                    video.play();
                    isPlaying = true;
                }

                // Increment scroll count
                scrollCount++;

                // Add class based on scroll count
                if (scrollCount === 1) {
                    videoWrapper.addClass("resize");
                } else if (scrollCount >= 3) {
                    videoWrapper.addClass("full-resize");
                }
            }
        }
    });*/
    


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partners-testimonial-carousel"] && !window.DesignMode) return;
  try {
    

    //swiper js
    var galleryTop = new Swiper('.partners-testimony', {
        //spaceBetween: 10,
        //autoplay: true,
        centeredSlides: true,
        direction: "vertical",
        effect: "slide",
        loop: true,
        loopedSlides: 5,
        speed: 1000,
        observer: true,
        observeParents: true,
    });

    var galleryThumbs = new Swiper('.partner-logos', {
        //spaceBetween: 10,
        //centeredSlides: true,
        autoplay: {
            disableOnInteraction: false
        },
        autoplay: false,
        slidesPerView: 5,
        //touchRatio: 0.2,
        slideToClickedSlide: true,
        loop: true,
        loopedSlides: 5,
        centeredSlides: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        freeMode: false,
        breakpoints: {
            320: {
                slidesPerView: 3.8,
                spaceBetween: 0,
            },
            499: {
                slidesPerView: 3.8,
                spaceBetween: 0,
            },
            991: {
                slidesPerView: 5,
                spaceBetween: 20,
            }
        }
    });

    galleryTop.controller.control = galleryThumbs;
    galleryThumbs.controller.control = galleryTop;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-card-gallery"] && !window.DesignMode) return;
  try {
    

  jQuery(document).ready(function(){
	   
    // Swiper initialization script
    var gallerySwiper = new Swiper('.gallery-container', {
      direction: 'horizontal',
      speed: 1000,
      spaceBetween: 40,
      autoplay: false,
      navigation: {
          nextEl: '.van--gallery-nav-buttons .swiper-button-next',
          prevEl: '.van--gallery-nav-buttons .swiper-button-prev',
      },
      pagination: {
          el: '.swiper-pagination',
          type: 'progressbar', // Progress bar type
      },
      breakpoints: {
          200: { width: 330, spaceBetween: 20 },
          768: { width: 305, spaceBetween: 30 },
          1024: { width: 325, spaceBetween: 30 },
          1280: { width: 350, spaceBetween: 30 },
          1536: { width: 400, spaceBetween: 40 },
          1600: { width: 450, spaceBetween: 40 },
          1920: { width: 450, spaceBetween: 40 },
      },
    });

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-animation"] && !window.DesignMode) return;
  try {
    

    //the mobile version
    // swiper js
    const swiper = new Swiper('.fourColumn-mobile', {
        direction: 'horizontal',
        loop: false,
        speed: 1000,
        spaceBetween: 20,
        autoplay: false,
        observer: true,
        observeParents: true,
        autoHeight: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable:'true'
        }
    });
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-with-slider"] && !window.DesignMode) return;
  try {
    

    //the mobile version
    // swiper js
    const swiper = new Swiper('.bannerMobile-block', {
        direction: 'horizontal',
        loop: false,
        speed: 1000,
        spaceBetween: 20,
        autoplay: false,
        observer: true,
        observeParents: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable:'true'
        }
    });
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-product"] && !window.DesignMode) return;
  try {
    
  //variant colors
  jQuery(document).ready(function(){
    $('.customVariant-color').click(function() {
      // Remove active class from all customVariantColor-items
      $('.customVariantColor-item').removeClass('active');
      // Add active class to the parent customVariantColor-item of the clicked customVariant-color
      $(this).closest('.customVariantColor-item').toggleClass('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-banner"] && !window.DesignMode) return;
  try {
    
   
    // Swiper js
    var quoteSwiper = new Swiper('.sliderBanner-contentsInner', {
        direction: "vertical",
        effect: "slide",
        autoHeight: true,
        loop: true,
        allowTouchMove: false,
        speed: 800,
        autoplay: true
    });

    var $Speed = 1000;

    var imageSwiper = new Swiper('.banner-slider', {
        effect: "fade",
        mousewheel: false,
        speed: $Speed,
        loop: true,
        longSwipesRatio: 0.01,
        followFinger: false,
        grabCursor: false, 
        watchSlidesProgress: false,
        parallax: false,
        lazy: {
            loadPrevNext: true,
        },
        autoplay: true,
        /*navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }*/
    });

    imageSwiper.controller.control = this.quoteSwiper;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-products"] && !window.DesignMode) return;
  try {
    

  var swiper_slider_p = new Swiper('.swiper-slider-products', {
    effect: 'slide',
    autoplay: false,
    on: {
      slideChangeTransitionStart: function() {
        var previousSlide = this.slides[this.previousIndex];
        previousSlide.style.opacity = 0;
      },
      slideChangeTransitionEnd: function() {
        var activeSlide = this.slides[this.activeIndex];
        activeSlide.style.opacity = 1;
      }
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    }
  }); 
  swiper_slider_p.on('slideNextTransitionStart', function() {
    var previousButton = document.querySelector('.swiper-slider-products .swiper-button-prev');
    previousButton.classList.add('dark');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-selling-animation"] && !window.DesignMode) return;
  try {
     

// Check if Swiper initialization code is already executed
if (!window.swiperInitialized) {
    const interleaveOffset = 0.75;

    // Select all swiper containers
    document.querySelectorAll('.subSelling-slider').forEach(container => {
        // Initialize Swiper for each container
        var swiper = new Swiper(container, {
            direction: 'vertical',
            speed: 800,
            mousewheelControl: false,
            watchSlidesProgress: true,
            mousewheel: {
                releaseOnEdges: true,
                eventsTarget: container, // Target mousewheel events to the specific swiper container
            },
            pagination: {
                el: container.querySelector('.swiper-pagination'), // Use pagination element inside the current swiper container
                clickable: true,
                type: 'bullets',

                renderBullet: function (index, className) {
                    return '<span class="' + className + '"><div class="custom-bullet"></div></span>';
                }
            },

            on: {
                progress: function() {
                    let swiper = this;

                    for (let i = 0; i < swiper.slides.length; i++) {
                        let slideProgress = swiper.slides[i].progress;
                        let innerOffset = swiper.height * interleaveOffset;
                        let opacity = 1 - Math.min(Math.abs(slideProgress), 1);
                        
                        swiper.slides[i].style.opacity = opacity;
                    }
                },
                setTransition: function(slider, speed) {
                    let swiper = this;
                    for (let i = 0; i < swiper.slides.length; i++) {
                        swiper.slides[i].style.transition = 'opacity ' + speed + 'ms';
                    }
                }
            }
        });
    });

    // Set a flag to indicate that Swiper initialization code is executed
    window.swiperInitialized = true;
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-product-items"] && !window.DesignMode) return;
  try {
    
	   
    // swiper js
    document.addEventListener('DOMContentLoaded', function() {  
        function initializeSwiper(selector) {
        return new Swiper(selector, {
            direction: 'horizontal',
            speed: 1000,
            spaceBetween: 30,
            autoplay: false,

            navigation: {
                nextEl: '.best-sale-content .swiper-button-next',
                prevEl: '.best-sale-content .swiper-button-prev',
            },
            pagination: {
                el: selector +' .swiper-pagination',
                type: 'progressbar',
            },
            breakpoints: {
                200: { width: 330, spaceBetween: 15 },
                430: { width: 330, spaceBetween: 15 },
                768: { width: 305},
                1024: { width: 330 },
                1280: { width: 350 },
                1536: { width: 400 },
                1600: { width: 475 },
                1920: { width: 475 },
            },
        });
        }

        function initializeSwiperForTab(tab) {
        const carousel = tab.querySelector('.swiper-best-sale');
        const carouselId = carousel.dataset.carouselId;
        initializeSwiper(`[data-carousel-id="${carouselId}"]`);
        }

        function initializeSwipersForActiveTab() {
        const activeTab = document.querySelector('.best-sale-content .tab-pane.active');
        if (activeTab) {
            initializeSwiperForTab(activeTab);
        }
        }

        document.querySelectorAll('.best-sale-nav-tabs .nav-link').forEach(tab => {
        tab.addEventListener('click', () => {
            document.querySelectorAll('.best-sale-nav-tabs .nav-link').forEach(tab => {
            tab.classList.remove('active');
            });
            tab.classList.add('active');
            initializeSwipersForActiveTab();
        });
        });

        initializeSwipersForActiveTab();
    
        //toggle variant colors
        var colorItems = document.querySelectorAll('.variant-option-block .variant-colors .variant-color-item');

        colorItems.forEach(function(colorItem) {
            colorItem.addEventListener('click', function() {

            var siblings = this.parentElement.querySelectorAll('.variant-color-item');
            siblings.forEach(function(sibling) {
                sibling.classList.remove('on');
            });

            this.classList.add('on');

            var productItem = this.closest('.product-item');
            var imgItem = productItem.querySelector('.variant-img-item img');
            imgItem.src = this.getAttribute('data-product-img');
            });
        });
    });
	

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !window.DesignMode) return;
  try {
    

    // swiper js
    const swiper = new Swiper('.swiper-testimonials', {
        direction: 'horizontal',
        loop: true,
        speed: 1000,
        spaceBetween: 25,
        autoplay: true,
        
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        breakpoints: {
            320: {
                slidesPerView: 1.1,
            },
            480: {
                slidesPerView: 1,
            },
            991: {
                slidesPerView: 1,
            }
        }

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-column-animation"] && !window.DesignMode) return;
  try {
    

    const sections = [
        { txt: ".wrap span.one", img: ".wrap div.one" },
        { txt: ".wrap span.two", img: ".wrap div.two" },
        { txt: ".wrap span.three", img: ".wrap div.three" },
    ];

    var scrollProgress = 0;

    gsap.timeline({
        defaults: {
            duration: 1,
            ease: "power2.inOut",
        },
        scrollTrigger: {
            trigger: ".wrap",
            scrub: 0.5,
            onUpdate: (self) => {
                scrollProgress = self.progress;
            },
            start: "top top+=1",
            end: "+=1800",
            pin: ".wrap",
            snap: false,
            // Add a condition to check if .vanpower-header has class 'sticky'
            //markers: true,
            onEnter: () => {
                if (document.querySelector('.vanpower-header').classList.contains('sticky')) {
                    // Continue with the animation only if .vanpower-header has class 'sticky'
                    gsap.timeline().progress(scrollProgress);
                }
            },
        },
    })
        .to(sections[0].txt, { autoAlpha: 0, delay: 0.2 }, ">")
        .to(sections[0].img, { autoAlpha: 0, y: -20 }, "<")
        .from(sections[1].txt, { autoAlpha: 0 })
        .from(sections[1].img, { autoAlpha: 0, y: 20 }, "<")
        .to(sections[1].txt, { autoAlpha: 0, delay: 0.2 }, ">")
        .to(sections[1].img, { autoAlpha: 0, y: -20 }, "<")
        .from(sections[2].txt, { autoAlpha: 0 })
        .from(sections[2].img, { autoAlpha: 0, y: 20 }, "<")
        .to(sections[2].txt, { autoAlpha: 1, delay: 0.2 }, ">")
        .to(sections[2].img, { autoAlpha: 1, y: -20 }, "<");

    // Set up a scroll listener for manual control
    document.addEventListener("wheel", (event) => {
        // Check if the user is scrolling down and if scrollProgress is less than 1
        if (event.deltaY > 0 && scrollProgress < 1) {
            // Increment the scrollProgress to simulate 1x scroll
            scrollProgress += 1; // You can adjust the increment value
            gsap.timeline().progress(scrollProgress);
        }
    });


    //the mobile version
    // swiper js
    const swiper = new Swiper('.twoColumn-mobileAnimation', {
        direction: 'horizontal',
        loop: false,
        speed: 1000,
        spaceBetween: 20,
        autoplay: false,
        observer: true,
        observeParents: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-column-slider"] && !window.DesignMode) return;
  try {
    

    // Your configuration options
    var commonSwiperOptions = {
        direction: "vertical",
        effect: "slide",
        loop: false,
        allowTouchMove: false,
    };

    // Create a common Swiper instance for all elements with the class '.quote-slider'
    var quoteSlider = new Swiper('.quote-slider', commonSwiperOptions);

    var $Speed = 1000;

    // Additional configuration options for '.image-slider'
    var imageSwiperOptions = {
        direction: "vertical",
        mousewheel: true,
        //effect: "fade",
        speed: $Speed,
        loop: false,
        longSwipesRatio: 0.01,
        followFinger: false,
        grabCursor: true,
        watchSlidesProgress: true,
        parallax: true,
        lazy: {
            loadPrevNext: true,
        },
    };

    // Select all elements with the class '.image-slider' and create a Swiper instance for each
    var imageSliders = document.querySelectorAll('.image-slider');

    imageSliders.forEach(function (element) {
        var imageSwiper = new Swiper(element, imageSwiperOptions);

        // Link the controllers
        if (quoteSlider) {
            imageSwiper.controller.control = quoteSlider;
        }
    });


    /*var imageSwiper = new Swiper('.image-slider', {
        direction: "vertical",
        mousewheel: true,
        effect: "fade",
        speed: $Speed,
        loop: false,
        longSwipesRatio: 0.01,
        followFinger: false,
        grabCursor: true, 
        watchSlidesProgress: true,
        parallax: true,
        lazy: {
            loadPrevNext: true,
        },
    });

    imageSwiper.controller.control = quoteSwiper;*/

    /*function initializeSwipers(containerSelector, swiperClass, options) {
        var containers = document.querySelectorAll(containerSelector);
        var swiperInstances = [];

        containers.forEach(function (container) {
            swiperInstances.push(new Swiper(container.querySelector('.' + swiperClass), options));
        });

        return swiperInstances;
    }

    var commonOptions = {
        direction: "vertical",
        loop: false,
    };

    // Initialize quoteSwipers
    var quoteSwipers = initializeSwipers('.quote-slider-container', 'quote-slider', {
        ...commonOptions,
        effect: "slide",
        allowTouchMove: false,
    });

    // Initialize imageSwipers
    var $Speed = 1000;
    var imageSwipers = initializeSwipers('.image-slider-container', 'image-slider', {
        ...commonOptions,
        mousewheel: true,
        effect: "fade",
        speed: $Speed,
        longSwipesRatio: 0.01,
        followFinger: false,
        grabCursor: true,
        watchSlidesProgress: true,
        parallax: true,
        lazy: {
            loadPrevNext: true,
        },
    });

    // Make imageSwiper control quoteSwiper
    imageSwipers.forEach(function (imageSwiper) {
        imageSwiper.controller.control = quoteSwipers;
    });*/
    


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urbanGlideSeries"] && !window.DesignMode) return;
  try {
    
    //update the product image based on the variant dots colors
    $(function(){
        $(".variant-option-block .variant-colors .variant-color-item").click(function(){
            $(this).addClass("on").siblings('.variant-color-item').removeClass('on');
            $(this).parents('.product-item').find('.variant-img-item img').attr('src', $(this).attr('data-product-img'));
        })
    })

    //buy now button for urbanglide series section
    $('.product-item .buyNow').click(function() {
        const buyButton = $(this);
        const model = buyButton.data('model').toLowerCase();

        window.open(`/cart?model=${model}&view=${model}`);
    });


     // swiper js
    const swiper = new Swiper('.urbanGlideSeries-mobile .prods', {
        direction: 'horizontal',
        loop: false,
        speed: 1000,
        spaceBetween: 10,
        slidesPerView: 2.2,
        autoplay: false,
        observer: true,
        observeParents: true,

        /*navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }*/
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-swiper"] && !window.DesignMode) return;
  try {
    

  // swiper js
 document.addEventListener('DOMContentLoaded', function() {
      function initializeSwiper(selector) {
      return new Swiper(selector, {
          direction: 'horizontal',
          speed: 1000,
          // width: 500,
          spaceBetween: 30,
          autoplay: false,


          // slidesPerView: 2,
          // loop: true,

          navigation: {
              nextEl: '.video-swiper-wrapper .swiper-button-next',
              prevEl: '.video-swiper-wrapper .swiper-button-prev',
          },
          pagination: {
              el: '.video-swiper-wrapper .swiper-pagination',
              type: 'progressbar',
          },
          breakpoints: {
            200: { width: 275, spaceBetween: 15,slidesPerView: 1, },
            430: { width: 271, spaceBetween: 15,slidesPerView: 1, },
            768: { width: 305,slidesPerView: 1, },
            1024: { width: 235 },
            1280: { width: 294 },
            1536: { width: 363 },
            1600: { width: 368 },
            1920: { width: 454 },
          },
      });
      }

      initializeSwiper('.video-swiper-wrapper .swiper-best-sale');

      window.addEventListener('resize', initializeSwiper('.video-swiper-wrapper .swiper-best-sale'))
    
    function setVideoHeight() {
      var containerHieght = $('.video-swiper-wrapper .swiper-slide').width();
      $('.video-swiper-wrapper .swiper-video').height(containerHieght * (9 / 16))
    }
    setVideoHeight();
    window.addEventListener('resize', setVideoHeight)
  });

  } catch(e) { console.error(e); }
})();
})();
